import type {Middleware} from '@reduxjs/toolkit'

/** 주문서 관련  */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const logger: Middleware = () => (next) => (action: any) => {
    if (/rejected$/.test(action.type)) {
        const {meta, ...rest} = action
        // eslint-disable-next-line no-console
        console.log(rest)
    }
    next(action)
}

export default logger
